import React, { useState, useMemo, useCallback, useEffect } from "react";
import {
  Box,
  IconButton,
  Stack,
  Modal,
  Button,
  CircularProgress,
  Typography,
} from "@mui/material";
import {
  SendRounded,
  Edit,
} from "@mui/icons-material";
import axios from "axios";

import { defaultemailTemplates, emailOptions } from "./staticData";
import { cleanQuillHtml, generateSectionHtml } from "./commonFunctions";
import { useNavigate } from "react-router-dom";
const EmailConfirmationModal = ({
  theme,
  emailType,
  title,
  modalStyle,
  handleSendMail,
}) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [template, setTemplate] = useState("");
  const [loading, setLoading] = useState(false);

  const loadTemplate = async () => {
    try {
      setLoading(true);
      const data = await fetchTemplate(emailType);
      setTemplate(data);
    } finally {
      setLoading(false);
    }
  };
  const fetchTemplate = async (id) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/gettemplate/${id}`
      );
      const savedTemplate = response?.data?.data;
      // console.log("response?.data?.data", response?.data?.data);
      if (savedTemplate) {
        return savedTemplate;
      } else {
        return defaultemailTemplates[id];
      }
    } catch (err) {
      console.error("Error fetching templates:", err);
      return defaultemailTemplates[id];
    }
  };

  const handleOpen = async () => {
    setOpen(true);
    loadTemplate();
  };

  const handleClose = () => setOpen(false);

  const PreviewPanel = ({ theme, html }) => {
    if (!html) {
      return (
        <div
          className="preview"
          dangerouslySetInnerHTML={{ __html: <p>Template not found</p> }}
        />
      );
    }
    // replacement setup
    const replacements = {
      "{{MERCHANT_NAME}}": theme?.shopName,
      "{{THEME_NAME}}": theme?.themeSchemaName,
      "{{STORE_URL}}": theme?.domain,
      "{{SUPPORT_LINK}}":
        "https://support.shinedezign.com/submitticket.php?step=2&deptid=5",
      "{{SUPPORT_EMAIL}}": "themes.shinedezign@gmail.com",
      "{{DOCS_LINK}}":
        "https://help.shopify.com/en/manual/online-store/themes/theme-support/documentation",
      "{{THEME_CUSTOMIZATION_URL}}": `https://admin.shopify.com/store/${theme?.shopName}/themes/${theme?.themeId}/editor`,
    };

    let templateHtml = html;

    Object.entries(replacements).forEach(([key, value]) => {
      const safeKey = key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      const regex = new RegExp(safeKey, "g");
      templateHtml = templateHtml?.replace(regex, value || "");
    });

    return (
      <div
        className="preview"
        dangerouslySetInnerHTML={{ __html: templateHtml }}
      />
    );
  };
  return (
    <>
      <IconButton
        onClick={handleOpen}
        size="small"
        sx={{
          backgroundColor: "#F3F4F6",
          width: "28px",
          height: "28px",
          color: "black",
          "&:hover": {
            backgroundColor: "#e5e6e8",
          },
        }}
      >
        <SendRounded sx={{ fontSize: 14 }} />
      </IconButton>

      <Modal open={open} onClose={handleClose}>
        <Box sx={{ ...modalStyle }}>
          <Box
            sx={{
              paddingInline: "12px",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              background: "#ffffffff",
            }}
          >
            <Typography
              fontWeight={600}
              fontSize="0.8rem"
              sx={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              Subject : {template?.subject}
            </Typography>

            <IconButton
              size="small"
              onClick={() => navigate(`/email-template-editor/${emailType}`)}
            >
              <Edit fontSize="small" color="primary" />
            </IconButton>
          </Box>

          <Box
            sx={{
              border: "1px solid #ddd",
              borderRadius: 2,
              height: "300px",
              overflow: "auto",
              padding: 1,
              mb: 2,
            }}
          >
            {loading ? (
              <Box display="flex" justifyContent="center" mt={8}>
                <CircularProgress size={30} />
              </Box>
            ) : (
              <PreviewPanel
                theme={theme}
                html={template?.html || generateSectionHtml(template?.body)}
              />
            )}
          </Box>

          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button variant="outlined" onClick={handleClose}>
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={() => {
                handleSendMail(theme, emailType);
                handleClose();
              }}
              disabled={loading}
            >
              Send
            </Button>
          </Stack>
        </Box>
      </Modal>
    </>
  );
};

export default EmailConfirmationModal;